export interface FileProps {
  href?: string
  hosted: string
  mimeType?: string
  size?: number
  percent?: any
  name?: string
}

export interface LinkProps {
  href: string
}

export interface ResourcesProps {
  id: string
  title: string
  description: string
  link?: LinkProps
  file?: FileProps
  transferRate?: string
  target?: any
  isCancelled?: boolean
}

export interface ResourceStatusProps {
  isLoading?: boolean
  isSubmitting?: boolean
  isUploading?: boolean
  isProcessing?: boolean
  hasError?: boolean
  submitSuccess?: boolean
  isDeleting?: boolean
  isEdit?: boolean
}

export interface SettingProps {
  supportedExtensions: string
  maxContentLength: string
  minContentLength: string
  regions?: any
}

export interface ResourcesInterface {
  view: string
  status: ResourceStatusProps
  activeResource?: ResourcesProps
  setting?: SettingProps
  uploader?: any
  interval?: string[]
}


const defaultState: ResourcesInterface  = {
  view: 'lists',
  status: {
    isLoading: false,
    isSubmitting: false,
    isUploading: false,
    isProcessing: false,
    hasError: false,
    submitSuccess: false
  }
}

export default defaultState
